import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setActivePlan, clearPlanSection } from 'actions/plans';
import { clearAssessments } from 'actions/assessments';
import { COMPULSORY_SCHOOL, PRESCHOOL, UPPER_SECONDARY_EDUCATION, ADULT_EDUCATION } from 'constants/schoolTypes';
import CompulsoryPlan from './Types/CompulsoryPlan';
import PreschoolPlan from './Types/PreschoolPlan';

var PlanningWrapper = /*#__PURE__*/function (_Component) {
  _inherits(PlanningWrapper, _Component);

  var _super = _createSuper(PlanningWrapper);

  function PlanningWrapper(props) {
    var _this;

    _classCallCheck(this, PlanningWrapper);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.setActivePlan();

      _this.props.clearPlanSection();

      _this.props.clearAssessments();
    });

    _this.state = {
      loading: false
    };
    return _this;
  }

  _createClass(PlanningWrapper, [{
    key: "render",
    value: function render() {
      if (this.props.currentUser == null) {
        return;
      } else {
        switch (this.props.currentUser.schools.getActiveSchool(this.props.currentUser.userId).type) {
          case PRESCHOOL:
            return /*#__PURE__*/React.createElement(PreschoolPlan, {
              params: this.props.match.params
            });

          case COMPULSORY_SCHOOL:
            return /*#__PURE__*/React.createElement(CompulsoryPlan, {
              params: this.props.match.params
            });

          case UPPER_SECONDARY_EDUCATION:
            return /*#__PURE__*/React.createElement(CompulsoryPlan, {
              params: this.props.match.params
            });

          case ADULT_EDUCATION:
            return /*#__PURE__*/React.createElement(CompulsoryPlan, {
              params: this.props.match.params
            });

          default:
            return /*#__PURE__*/React.createElement("div", null);
        }
      }
    }
  }]);

  return PlanningWrapper;
}(Component);

function mapStateToProps(state) {
  return {
    currentUser: state.user.currentUser
  };
}

export default connect(mapStateToProps, {
  setActivePlan: setActivePlan,
  clearPlanSection: clearPlanSection,
  clearAssessments: clearAssessments
})(PlanningWrapper);